<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/businessUnitList' }">业务单元</el-breadcrumb-item>
                <el-breadcrumb-item>业务单元{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'xxxx'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="item['prop'] == 'code' && type == 'update'"
                                        clearable
                                    ></el-input>
                                    <el-tooltip
                                        v-if="
                                            fieldTypeMap.hasOwnProperty(item.prop) &&
                                            fieldTypeMap[item.prop].hasOwnProperty('tips') &&
                                            ((item.prop == 'code' && type == 'insert') || item.prop != 'code')
                                        "
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>

                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'businessUnitEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.initFormData();
        }
    },
    methods: {
        in_array,
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                province_rid: {
                    request_uri: 'provinces',
                    title: '省份',
                    ref: 'province_rid_ref',
                    type: 'dropdown',
                    is_init: true
                },
                parent_rid: {
                    request_uri: 'dropdownBusinessUnits',
                    title: '父级业务单元',
                    ref: 'parent_rid_ref',
                    type: 'dropdown'
                },
                person_rid: {
                    request_uri: 'dropdownPerson',
                    title: '人员',
                    ref: 'person_rid_ref',
                    type: 'dropdown',
                    is_init: true
                },
                type_code: {
                    request_uri: 'dropdownBusinessUnitType',
                    title: '类型',
                    ref: 'type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                code: {
                    tips: '不填，默认为自增'
                }
            };
        },
        initFormRule() {
            this.rules = {
                code: [{ required: false, message: '请输入编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                label: [{ required: false, message: '请输入标签', trigger: 'blur' }],
                group_label: [{ required: false, message: '请输入组标签', trigger: 'blur' }],
                province_rid: [{ required: false, message: '请选择省份', trigger: 'blur' }],
                person_rid: [{ required: false, message: '请选择人员', trigger: 'blur' }],
                parent_rid: [{ required: false, message: '请选择父级', trigger: 'blur' }],
                type_code: [{ required: false, message: '请选择类型', trigger: 'blur' }]
            };
        },

        initQueryParams() {
            this.queryParams.rid = this.$route.query.rid;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                code: this.data.code || '',
                name: this.data.name || '',
                label: this.data.label || '',
                group_label: this.data.group_label || '',
                authentication_rid: this.data.authentication_rid || '',
                province_rid: this.data.province_rid || '',
                person_rid: this.data.person_rid || '',
                type_code: this.data.type_code || '',
                parent_rid: this.data.parent_rid || ''
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).business_unit;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['code', 'name', 'label', 'group_label']
                },
                {
                    type: 'type_code',
                    province_name: 'province_rid',
                    person: 'person_rid',
                    parent_name: 'parent_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: 'businessUnitList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .businessUnitDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'businessUnitUpdate';
            } else {
                uri = 'businessUnitInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>